/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';

const formatNumber = value => {
  if (value === undefined || value === null || value === '-') return '-';
  const num = typeof value === 'string' ? parseFloat(value) : value;
  return num.toLocaleString('th-TH', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

const CustomerInfo = ({ customer, billdata }) => {
  const [memberDetails, setMemberDetails] = useState(null);

  useEffect(() => {
    const prepareMemberDetails = () => {
      let memberData = {
        customerName: '-',
        customerPhone: '-',
        point: {
          all: '-',
          receive: '-',
          usage: '-',
          remain: '-',
          total: '-'
        },
        discount: {
          endBill: '0.00',
          promotion: '0.00',
          point: '0.00'
        },
        payment: {
          items: []
        }
      };

      if (billdata?.member) {
        const billMember = billdata.member;
        const additionalDataPoints = billdata.additional_data?.point || {};

        memberData = {
          ...memberData,
          customerName: `${billMember.first_name_th || ''} ${billMember.last_name_th || ''}`.trim(),
          customerPhone: billMember.phone_number,
          point: {
            all: additionalDataPoints.total || 0,
            receive: additionalDataPoints.earned || 0,
            usage: additionalDataPoints.spend || 0,
            remain: additionalDataPoints.remain || 0,
            total: additionalDataPoints.remain || 0
          }
        };
      }

      if (billdata && billdata.billStatus === 3) {
        memberData = {
          ...memberData,
          discount: {
            endBill: billdata.orderPrice?.discount || billdata.discount_amount || '0.00',
            promotion: '0.00',
            point: billdata.discount_points || '0.00'
          },
          payment: {
            items:
              billdata.payment?.map(item => ({
                name: item.paymentMethod?.name || 'เงินสด',
                amount: item.price_after_cash_out !== 0 ? item.price_after_cash_out : item.price || '0.00'
              })) || []
          }
        };
      }
      setMemberDetails(memberData);
    };

    prepareMemberDetails();
  }, [billdata]);

  return (
    <div className="pe-3">
      <div className="fs-18 fw-500 text-[#2DC76D] mb-3">ข้อมูลสมาชิก</div>

      <div className="d-flex align-items-center mb-3">
        <img
          className="aspect-square w-[min(6.13vw,62px)] rounded-full object-cover"
          src="/img/avatar-female.png"
          alt=""
        />
        <div className="ms-3 fs-14 text-[#2F4858]">
          <div>{memberDetails?.customerName || '-'}</div>
          <div>{memberDetails?.customerPhone || '-'}</div>
        </div>
      </div>

      <div className="d-flex align-items-center mb-1">
        <div className="me-auto text-[#2F4858] fs-14 fw-light">แต้มสะสมที่มีอยู่</div>
        <div className="text-[#2F4858]">{formatNumber(memberDetails?.point?.remain)}</div>
      </div>
      <div className="d-flex align-items-center mb-1">
        <div className="me-auto text-[#2F4858] fs-14 fw-light">คะแนนสะสมที่ใช้</div>
        <div className="text-[#2F4858]">{formatNumber(memberDetails?.point?.usage)}</div>
      </div>
      <div className="d-flex align-items-center mb-1">
        <div className="me-auto text-[#2F4858] fs-14 fw-light">ได้รับคะแนนสะสม</div>
        <div className="text-[#2F4858]">{formatNumber(memberDetails?.point?.receive)}</div>
      </div>
      <div className="d-flex align-items-center mb-1">
        <div className="me-auto text-[#2F4858] fs-14 fw-light">คะแนนสะสมทั้งหมด</div>
        <div className="text-[#2F4858]">{formatNumber(memberDetails?.point?.all)}</div>
      </div>

      <hr />

      <div className="fs-18 fw-500 text-[#2DC76D] mb-2 mt-2">ส่วนลดและโปรโมชั่นที่ได้รับ</div>
      <div className="d-flex align-items-center mb-1">
        <div className="me-auto text-[#2F4858] fs-14 fw-light">ส่วนลดท้ายบิล</div>
        <div className="text-[#2F4858]">
          {formatNumber(
            billdata && billdata.billStatus === 3
              ? parseFloat(billdata.orderPrice?.discount || 0)
              : billdata && billdata.billStatus !== 3
              ? '0.00'
              : memberDetails?.discount?.endBill || '0.00'
          )}
        </div>
      </div>
      <div className="d-flex align-items-center mb-1">
        <div className="me-auto text-[#2F4858] fs-14 fw-light">ส่วนลดโปรโมชั่น</div>
        <div className="text-[#2F4858]">
          {formatNumber(billdata && billdata.billStatus === 3 ? '0.00' : memberDetails?.discount?.promotion || '0.00')}
        </div>
      </div>
      {/* <div className="d-flex align-items-center mb-1">
        <div className="me-auto text-[#2F4858] fs-14 fw-light">
          ส่วนลดการใช้คะแนน
        </div>
        <div className="text-[#2F4858]">
          {formatNumber(
            billdata && billdata.billStatus === 3 && billdata.discount_points
              ? parseFloat(billdata.discount_points || 0)
              : billdata && billdata.billStatus !== 3
              ? "0.00"
              : memberDetails?.discount?.point || "0.00"
          )}
        </div>
      </div> */}

      <hr />

      <div className="fs-18 fw-500 text-[#2DC76D] mb-2 mt-2">รายได้อื่นๆ</div>
      <div className="d-flex align-items-center mb-1">
        <div className="me-auto text-[#2F4858] fs-14 fw-light">
          Service Charge {billdata.service_charge_percent ? `(${billdata.service_charge_percent}%)` : ''}
        </div>
        <div className="text-[#2F4858]">
          {formatNumber(billdata && billdata.billStatus === 3 ? parseFloat(billdata.service_charge || 0) : '0.00')}
        </div>
      </div>
      <div className="d-flex align-items-center mb-1">
        <div className="me-auto text-[#2F4858] fs-14 fw-light">ค่าธรรมเนียมบัตรเครดิต</div>
        <div className="text-[#2F4858]">
          {formatNumber(billdata && billdata.billStatus === 3 ? parseFloat(billdata.credit_card_fee || 0) : '0.00')}
        </div>
      </div>

      <hr />

      <div className="fs-18 fw-500 text-[#2DC76D] mb-2 mt-2">ช่องทางการชำระเงิน</div>

      {memberDetails?.payment?.items && memberDetails.payment.items.length > 0 ? (
        memberDetails.payment.items.map((item, index) => (
          <div className="d-flex align-items-center mb-1" key={index}>
            <div className="me-auto text-[#565DFF] fs-14 fw-light">{item.name}</div>
            <div className="text-[#565DFF]">
              {billdata.billStatus === 5 ? 0 : formatNumber(parseFloat(item.amount))}
            </div>
          </div>
        ))
      ) : (
        <div className="d-flex align-items-center mb-1">
          <div className="me-auto text-[#565DFF] fs-14 fw-light">เงินสด</div>
          <div className="text-[#565DFF]">0.00</div>
        </div>
      )}
    </div>
  );
};

export default CustomerInfo;
